module.exports = __webpack_public_path__ + "static/media/ic-recommendation1.1.b3003c2e.png";